class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault(),
          (
            this.closest("cart-items") || this.closest("cart-drawer-items")
          ).updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.get("cart-remove-button") ||
  customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus")),
      document.querySelector(".cart-shipping") &&
        ((this.minSpend =
          document.querySelector(".cart-shipping").dataset.minSpend),
        (this.minTotal = Math.round(
          this.minSpend * (Shopify.currency.rate || 1)
        )),
        this.cartShipping());
    var e = debounce((e) => {
      this.onChange(e);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", e.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  cartShipping() {
    var e;
    (this.total = document.querySelector(".cart-shipping").dataset.total),
      (this.progress = (this.total / this.minTotal) * 100),
      100 < this.progress && (this.progress = 100),
      (this.minTotal > this.total
        ? ((e = this.minTotal - this.total),
          (e = document
            .querySelector(".cart-shipping")
            .dataset.message.replace("||amount||", formatMoney(e))),
          (document.querySelector(".cart-shipping__message_default").innerText =
            e),
          document
            .querySelector(".cart-shipping__message_success")
            .classList.remove("active"),
          document.querySelector(".cart-shipping__message_default"))
        : (document
            .querySelector(".cart-shipping__message_default")
            .classList.remove("active"),
          document.querySelector(".cart-shipping__message_success"))
      ).classList.add("active");
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      "cart-items" !== e.source && this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(e) {
    this.updateQuantity(
      e.target.dataset.index,
      e.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  onCartUpdate() {
    fetch(routes.cart_url + "?section_id=main-cart-items")
      .then((e) => e.text())
      .then((e) => {
        e = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("cart-items");
        this.innerHTML = e.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents-totals",
      },
      {
        id: "main-cart-shipping",
        section:
          document.getElementById("main-cart-shipping").dataset.id || null,
        selector: ".js-contents-shipping",
      },
    ];
  }
  updateQuantity(n, e, c) {
    this.enableLoading(n),
      this.querySelectorAll(".quantity__button").forEach((e) =>
        e.classList.add("disabled")
      ),
      document.querySelectorAll(
        '.card--product card__add-to-cart button[name="add"]'
      ) &&
        document
          .querySelectorAll(
            '.card--product .card__add-to-cart button[name="add"]'
          )
          .forEach((e) => {
            e.setAttribute("aria-disabled", !1),
              e.querySelector("span") &&
                (e.querySelector("span").classList.remove("hidden"),
                e.querySelector(".sold-out-message").classList.add("hidden"));
          });
    e = JSON.stringify({
      line: n,
      quantity: e,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_change_url, { ...fetchConfig(), body: e })
      .then((e) => e.text())
      .then((t) => {
        const r = JSON.parse(t);
        var t =
            document.getElementById("Quantity-" + n) ||
            document.getElementById("Drawer-quantity-" + n),
          s = document.querySelectorAll(".cart-item");
        if (r.errors)
          (t.value = t.getAttribute("value")),
            this.updateLiveRegions(n, r.errors);
        else {
          this.classList.toggle("is-empty", 0 === r.item_count);
          var i = document.querySelector("cart-drawer"),
            a = document.getElementById("main-cart-footer"),
            a =
              (a && a.classList.toggle("is-empty", 0 === r.item_count),
              i && i.classList.toggle("is-empty", 0 === r.item_count),
              this.getSectionsToRender().forEach((e) => {
                (
                  document.getElementById(e.id).querySelector(e.selector) ||
                  document.getElementById(e.id)
                ).innerHTML = this.getSectionInnerHTML(
                  r.sections[e.section],
                  e.selector
                );
              }),
              r.items[n - 1] ? r.items[n - 1].quantity : void 0);
          let e = "";
          s.length === r.items.length &&
            a !== parseInt(t.value) &&
            (e =
              void 0 === a
                ? window.cartStrings.error
                : window.cartStrings.quantityError.replace("[quantity]", a)),
            this.updateLiveRegions(n, e);
          s =
            document.getElementById("CartItem-" + n) ||
            document.getElementById("CartDrawer-Item-" + n);
          s && s.querySelector(`[name="${c}"]`)
            ? i
              ? trapFocus(i, s.querySelector(`[name="${c}"]`))
              : s.querySelector(`[name="${c}"]`).focus()
            : 0 === r.item_count && i
            ? trapFocus(
                i.querySelector(".drawer__inner-empty"),
                i.querySelector("a")
              )
            : document.querySelector(".cart-item") &&
              i &&
              trapFocus(i, document.querySelector(".cart-item__name")),
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
        }
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((e) =>
          e.classList.add("hidden")
        ),
          this.querySelectorAll(".quantity__button").forEach((e) =>
            e.classList.remove("disabled")
          );
        var e =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        e && (e.textContent = window.cartStrings.error);
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((e) =>
          e.classList.remove("disabled")
        ),
          document.querySelector(".cart-shipping") && this.cartShipping(),
          this.disableLoading(n);
      });
  }
  updateLiveRegions(e, t) {
    e =
      document.getElementById("Line-item-error-" + e) ||
      document.getElementById("CartDrawer-LineItemError-" + e);
    e &&
      ((e.style.display = "flex"),
      (e.querySelector(".cart-item__error-text").innerHTML = t)),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    const r =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    r.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        r.setAttribute("aria-hidden", !0);
      }, 1e3);
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  enableLoading(e) {
    var t = document.getElementById("main-cart-items");
    t &&
      (t.classList.add("cart__items--disabled"),
      this.querySelectorAll(`#CartItem-${e} .loading-overlay`).forEach((e) =>
        e.classList.remove("hidden")
      ),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1));
  }
  disableLoading(e) {
    var t = document.getElementById("main-cart-items");
    t &&
      (t.classList.remove("cart__items--disabled"),
      this.querySelectorAll(`#CartItem-${e} .loading-overlay`).forEach((e) =>
        e.classList.add("hidden")
      ));
  }
}
customElements.get("cart-items") ||
  customElements.define("cart-items", CartItems),
  customElements.get("cart-note") ||
    customElements.define(
      "cart-note",
      class extends HTMLElement {
        constructor() {
          super(),
            this.addEventListener(
              "change",
              debounce((e) => {
                e = JSON.stringify({ note: e.target.value });
                fetch("" + routes.cart_update_url, {
                  ...fetchConfig(),
                  body: e,
                });
              }, ON_CHANGE_DEBOUNCE_TIMER)
            );
        }
      }
    );
class CartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.header = document.querySelector(".header-wrapper")),
      this.header && (this.header.preventHide = !1),
      this.addEventListener(
        "keyup",
        (e) => "Escape" === e.code && this.close()
      ),
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      ),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const t = document.querySelector("#cart-icon-bubble");
    t.setAttribute("role", "button"),
      t.setAttribute("aria-haspopup", "dialog"),
      t.addEventListener("click", (e) => {
        e.preventDefault(), this.open(t);
      }),
      t.addEventListener("keydown", (e) => {
        "SPACE" === e.code.toUpperCase() && (e.preventDefault(), this.open(t));
      });
  }
  open(e) {
    this.header && (this.header.preventHide = !0),
      e && this.setActiveElement(e);
    e = this.querySelector('[id^="Details-"] summary');
    e && !e.hasAttribute("role") && this.setSummaryAccessibility(e),
      setTimeout(() => {
        this.classList.add("animate", "active");
      }),
      this.addEventListener(
        "transitionend",
        () => {
          var e = this.classList.contains("is-empty")
              ? this.querySelector(".drawer__empty")
              : document.getElementById("CartDrawer"),
            t =
              this.querySelector(".drawer__inner") ||
              this.querySelector(".drawer__close");
          trapFocus(e, t);
        },
        { once: !0 }
      ),
      document.body.classList.add("overflow-hidden-drawer");
  }
  close() {
    this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden-drawer"),
      this.header && (this.header.preventHide = !1);
  }
  setSummaryAccessibility(e) {
    e.setAttribute("role", "button"),
      e.setAttribute("aria-expanded", "false"),
      e.nextElementSibling.getAttribute("id") &&
        e.setAttribute("aria-controls", e.nextElementSibling.id),
      e.addEventListener("click", (e) => {
        e.currentTarget.setAttribute(
          "aria-expanded",
          !e.currentTarget.closest("details").hasAttribute("open")
        );
      }),
      e.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(t) {
    (this.productId = t.id),
      this.getSectionsToRender().forEach((e) => {
        (e.selector
          ? document.querySelector(e.selector)
          : document.getElementById(e.id)
        ).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector);
      }),
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener(
          "click",
          this.close.bind(this, !1)
        ),
          this.open();
      });
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }
  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
customElements.get("cart-drawer") ||
  customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
  enableLoading() {
    var e = document.querySelector(".cart-drawer__footer");
    e &&
      (e
        .querySelector(".totals__subtotal-value > span")
        .classList.add("disabled"),
      (e = e.querySelector(".loading-overlay")) && e.classList.remove("hidden"),
      document.activeElement.blur());
  }
  disableLoading() {
    var e = document.querySelector(".cart-drawer__footer");
    e &&
      (e
        .querySelector(".totals__subtotal-value > span")
        .classList.remove("disabled"),
      (e = e.querySelector(".loading-overlay"))) &&
      e.classList.add("hidden");
  }
}
customElements.get("cart-drawer-items") ||
  customElements.define("cart-drawer-items", CartDrawerItems);
